import script from "./sceneAudio.vue?vue&type=script&lang=js"
export * from "./sceneAudio.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__